module.exports = __webpack_public_path__ + "8b41552bfedbac70cf91dbd3e01250b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/ModulesLanding/module2.png
// module id = 1379
// module chunks = 0